import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

const COLLS = [["c1", "Metaland Wolfpack Exclusive"], ["c3", "Project PUPS"], ["c2", "Metaland Wolfpack"]];

export default function AdminNftArt() {
  const [rows, setRows] = useState([]);
  const [key, setKey] = useState("c1");
  const [num, setNum] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/nft-art").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);

  const pick = (f) => { setFile(f); setPreview(f ? URL.createObjectURL(f) : null); };
  const upload = async (e) => {
    e.preventDefault();
    if (!file || num === "") return toast.error("Pick a collection, type the NFT number and choose an image");
    setBusy(true);
    const fd = new FormData();
    fd.append("key", key); fd.append("token_id", num); fd.append("file", file);
    try {
      await api.post("/admin/nft-art", fd);
      toast.success(`Art saved for ${COLLS.find((c) => c[0] === key)[1]} #${num}`);
      pick(null); setNum(""); load();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const remove = async (r) => {
    if (!window.confirm(`Remove the uploaded art for #${r.token_id}? This can't be undone.`)) return;
    await api.delete(`/admin/nft-art/${r.key}/${r.token_id}`); toast("Art removed"); load(); };

  return (
    <div className="grid lg:grid-cols-[360px_1fr] gap-6">
      <form onSubmit={upload} className="glass rounded-2xl p-6 space-y-4" data-testid="nft-art-form">
        <h3 className="font-display text-xl text-amber-100">Upload NFT art</h3>
        <div className="flex flex-col gap-2">
          {COLLS.map(([k, n]) => (
            <label key={k} className={`flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer text-sm ${key === k ? "border-fuchsia-500 bg-fuchsia-500/10" : "border-slate-700"}`}>
              <input type="radio" name="coll" data-testid={`nft-art-coll-${k}`} checked={key === k} onChange={() => setKey(k)} className="accent-fuchsia-500" />{n}
            </label>
          ))}
        </div>
        <Input data-testid="nft-art-number-input" value={num} onChange={(e) => setNum(e.target.value.replace(/\D/g, ""))} placeholder="NFT number, e.g. 1147" className="bg-slate-900" />
        <label className="block rounded-xl border border-dashed border-slate-600 hover:border-fuchsia-500 p-4 text-center cursor-pointer">
          {preview ? <img src={preview} alt="preview" className="w-40 h-40 mx-auto rounded-lg object-cover" /> : <Upload className="w-6 h-6 mx-auto text-slate-400" />}
          <span className="block text-xs text-slate-400 mt-2">{file ? file.name : "Choose an image (PNG, JPG or WEBP, under 8 MB)"}</span>
          <input type="file" accept="image/*" data-testid="nft-art-file-input" className="hidden" onChange={(e) => pick(e.target.files?.[0] || null)} />
        </label>
        <button data-testid="nft-art-upload-btn" disabled={busy} className="ember-btn w-full py-3 rounded-lg text-sm">{busy ? "UPLOADING…" : "SAVE ART"}</button>
        <p className="text-[11px] text-slate-500">The art shows straight away in My Pack, battles and on the leaderboard for whoever holds that NFT.</p>
      </form>
      <div className="glass rounded-2xl p-6">
        <h3 className="font-display text-xl text-amber-100 mb-4">Uploaded art ({rows.length})</h3>
        {!rows.length && <p className="text-sm text-slate-500" data-testid="nft-art-empty">Nothing uploaded yet.</p>}
        <div className="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-6 gap-3" data-testid="nft-art-list">
          {rows.map((r) => (
            <div key={`${r.key}-${r.token_id}`} className="rounded-xl overflow-hidden border border-slate-700 bg-slate-950" data-testid={`nft-art-item-${r.key}-${r.token_id}`}>
              <img src={r.image} alt="" className="w-full aspect-square object-cover" />
              <div className="p-2 flex items-center justify-between text-xs">
                <span>{r.key === "c1" ? "Exclusive" : r.key === "c2" ? "Wolfpack" : "PUPS"} #{r.token_id}</span>
                <button data-testid={`nft-art-delete-${r.key}-${r.token_id}`} onClick={() => remove(r)} className="text-slate-500 hover:text-red-300" aria-label="Remove"><Trash2 className="w-3.5 h-3.5" /></button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
